import React, { Component } from "react";
import { Switch } from "react-router";
import { Layout } from "./Layout";
import { RouteWithLayout } from "./RouteWithLayout";
import { CustomerServicePage } from "../pages/customer-service/CustomerServicePage";

export class CustomerServiceSwitch extends Component {
  render() {
    return (
      <Switch>
        <RouteWithLayout layout={Layout} exact path="/" component={CustomerServicePage} />
      </Switch>
    );
  }
}
